import(/* webpackMode: "eager" */ "/vercel/path0/src/app/game/create/page.tsx");
